import { createContext, useContext } from "react";

const SoundContext = createContext({});

export const SoundContextProvider = SoundContext.Provider;
export const SoundContextConsumer = SoundContext.Consumer;

export const useSoundContext = () => useContext(SoundContext);

export default SoundContext;
